import { render, staticRenderFns } from "./myresourcesDetail.vue?vue&type=template&id=c1e3711a&scoped=true&"
import script from "./myresourcesDetail.vue?vue&type=script&lang=js&"
export * from "./myresourcesDetail.vue?vue&type=script&lang=js&"
import style0 from "./myresourcesDetail.vue?vue&type=style&index=0&id=c1e3711a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e3711a",
  null
  
)

export default component.exports